<template>
    <ColorPalette
        :value="selectedColor"
        :colorsGrid="getExtensionOptionColorsGrid()"
        :tooltip="getExtensionOptionLabel()"
        :icon="getExtensionOptionIcon()"
        :active="active"
        :disabled="disabled"
        :isVisible="showColorPalette"
        @update:visibility="updateVisibility"
        @update:value="updateColor"
        @reset:value="resetColor"
    />
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';
import ColorPalette from 'vcomponents/common/Inputs/ColorPalette.vue';

export default {
    components: {
        ColorPalette,
    },
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            showColorPalette: false,
            selectedColor: '',
        };
    },
    computed: {
        active() {
            return (
                this.editor.isActive('textStyle') && !!this.editor.getAttributes('textStyle').color
            );
        },
    },
    methods: {
        getExtensionOptionLabel() {
            return this.$t.__(this.getExtensionOption(this.option).label);
        },
        getExtensionOptionIcon() {
            return this.getExtensionOption(this.option).icon;
        },
        getExtensionOptionColorsGrid() {
            return this.getExtensionOption(this.option).colorsGrid;
        },
        updateColor(color) {
            this.selectedColor = color;
            this.editor.chain().focus().setColor(this.selectedColor).run();
        },
        resetColor() {
            this.selectedColor = '';
            this.editor.chain().focus().unsetColor().run();
        },
        updateVisibility(visible) {
            this.selectedColor = '';
            this.showColorPalette = visible;

            if (this.showColorPalette && this.active) {
                this.selectedColor = this.editor.getAttributes('textStyle').color;
            }
        },
    },
};
</script>
